export default {
  scheduled_order: 'Zamówienie zaplanowane',
  show_more: 'Pokaż więcej',
  show_less: 'Pokaż mniej',
  schedule_order: 'Zaplanuj zamówienie',
};
